import { useNavigate } from 'react-router';
import { Box, IconButton, Toolbar } from '@mui/material';
import { StyledAppBar } from './styles';
import { WhiteLogoIcon } from '@/components/Icons/Icons';
import { RouteMap } from '@/routes/Routes';

export const LoginNavbar = () => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(RouteMap.ROOT);
  };

  return (
    <Box sx={{ flexGrow: 1 }}>
      <StyledAppBar sx={{ border: 'none' }}>
        <Toolbar>
          <IconButton onClick={handleLogoClick}>
            <WhiteLogoIcon sx={{ width: '204.8px', height: '32px' }} />
          </IconButton>
        </Toolbar>
      </StyledAppBar>
    </Box>
  );
};
